import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../components/Icon'
import { mapServiceTypeToTitle } from '../constants'
import CustomLink from '../components/CustomLink'

const ServiceHeading = (props) => {
    return (
        <div className='service-details module'>
            <div className='module-inner py-3 px-4 p-lg-4'>
                <div className='row position-relative'>
                    <div className={`col-12 ${props.children ? props.colClassLg : ''} d-flex align-items-center`}>
                        <Icon src={props.icon} className='icon text-center' />
                        <div>
                            <div><small>{props.smallText}</small></div>
                            <h3 className='my-0 lime' dangerouslySetInnerHTML={{ __html: mapServiceTypeToTitle[props.type] }} />
                            <div><small>{props.medText}</small></div>
                        </div>
                    </div>
                    {props.children ? props.children : ''}
                </div>
            </div>
        </div>
    )
}

ServiceHeading.propTypes = {
    icon: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    smallText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    medText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    colClassLg: PropTypes.string
}

ServiceHeading.defaultProps = {
    colClassLg: 'col-lg-6'
}

export default ServiceHeading



// WEBPACK FOOTER //
// ./resources/js/modules/ServiceHeading.js